import React from "react";
import { images } from "../mock";

const About = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
        {/* Image with decorative frame */}
        <div className="relative">
          <div className="absolute -top-6 -left-6 w-40 h-40 rounded-full border-4 border-[color:var(--brand-teal)] opacity-70" />
          <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[color:var(--brand-red)] opacity-90" />
          <img
            src={images.about}
            alt="ERM movers handling boxes"
            className="relative w-full h-[460px] object-cover rounded-sm shadow-xl"
          />
        </div>

        {/* Text */}
        <div>
          <h2 className="font-display text-4xl md:text-5xl font-bold">
            ABOUT <span className="text-[color:var(--brand-red)]">US</span>
          </h2>
          <div className="h-1 w-16 bg-[color:var(--brand-red)] mt-3 mb-6" />

          <p className="text-gray-700 leading-relaxed">
            At <span className="font-semibold text-[color:var(--brand-red)]">ERM CARGO & PACKAGING L.L.C.</span>, we believe relocation is more than movement—it&apos;s a promise of precision, care, and trust. Founded on the principle that every shipment tells a story, we merge operational excellence with a refined approach, ensuring that each delivery reflects the values of the customer it represents.
          </p>
          <p className="text-gray-700 leading-relaxed mt-4">
            We are a boutique shipping and logistics company that specializes in high-touch, design-conscious cargo solutions. Whether it&apos;s luxury goods, curated collections, or sensitive freight, our team handles each shipment with an eye for detail and a commitment to seamless execution.
          </p>

          <div className="mt-8 grid grid-cols-3 gap-6 max-w-md">
            <Stat number="5+" label="Years" />
            <Stat number="150+" label="Destinations" />
            <Stat number="500+" label="Moves" />
          </div>
        </div>
      </div>
    </section>
  );
};

const Stat = ({ number, label }) => (
  <div className="text-center">
    <div className="font-display text-3xl font-bold text-[color:var(--brand-teal)]">{number}</div>
    <div className="text-xs uppercase tracking-wider text-gray-500 mt-1">{label}</div>
  </div>
);

export default About;
